module.exports = __webpack_public_path__ + "img/hn.1135f601.svg";